import Icon, { iconComponentPropTypes } from './Icon';
import IconText from './IconText';
export default Icon;
export { iconComponentPropTypes, IconText };